<!--
 * @Descripttion: 带table列表的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 22:08:03
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-01 15:16:16
-->
<template>
	<div>
		<el-drawer
			:title="title"
			:visible.sync="visible"
			:append-to-body="appendToBody"
			:size="1000"
			:before-close="handleClose"
			:wrapperClosable="wrapperClosable"
			custom-class="drawer-template"
		>
			<div class="content">
				<!-- 弹窗内容部分 -->
				<el-table :data="list" header-row-class-name="table-header-row" row-class-name="table-row" v-loading="loading">
					<el-table-column label="商家账号" min-width="130">
						<template slot-scope="{ row }">
							<TextCell :row="row" :column="{ key: 'bindCompanyName' }" />
						</template>
					</el-table-column>
					<el-table-column label="联系人信息" min-width="150">
						<template slot-scope="{ row }">
							<div class="flex-row flex-align-center">
								<el-tooltip placement="top" :content="row.sellerName" v-ak-tooltip-auto-show>
									<span class="line-ellipsis-1 ml-4" style="max-width: 100%">{{ row.sellerName }}</span>
								</el-tooltip>
								<sellerIntroduction class="ml-4" :wechat="row.sellerWechat" :mobile="row.sellerPhone" />
							</div>
						</template>
					</el-table-column>
					<el-table-column label="绑定时间" min-width="170">
						<template slot-scope="{ row }">
							<span>{{ row.bindTime | formatDateTime }}</span>
						</template>
					</el-table-column>
					<el-table-column label="邀请者" min-width="120">
						<template slot-scope="{ row }">
							<TextCell :row="row" :column="{ key: 'partnerRoleName' }" />
						</template>
					</el-table-column>
					<el-table-column label="状态" min-width="100">
						<template slot-scope="{ row }">
							<statusCell :row="row" :column="{ key: 'bindStatus' }" />
						</template>
					</el-table-column>
					<el-table-column label="操作" prop="operates" min-width="180" align="right">
						<template slot-scope="{ row }">
							<el-button type="text" @click="closeBind(row.bindId)" v-if="+row.bindStatus === 1">取消绑定</el-button>
							<el-button type="text" @click="closeBindReason(row.remarks)" v-else>查看解绑原因</el-button>
						</template>
					</el-table-column>
				</el-table>
				<yx-pagination
					:total="total"
					:current-page="pageInfo.page_index"
					:page-size="pageInfo.page_size"
					@size-change="sizeChange"
					@current-change="currentChange"
				></yx-pagination>
			</div>
		</el-drawer>

		<!-- 绑定弹框 -->
		<close-bind-dialog ref="closeBindDialog" @refresh="refresh" :platformId="platformId" />

		<!-- 解绑原因 -->
		<reason-dialog ref="reasonDialog" />
	</div>
</template>
<script>
import TextCell from './tableCells/TextCell.vue';
import statusCell from './tableCells/statusCell.vue';
import sellerIntroduction from './sellerIntroduction';
import closeBindDialog from './closeBindDialog.vue';
import reasonDialog from './reasonDialog.vue';
import { cooperativeList } from '@/api/cooperativeShop';
export default {
	components: {
		TextCell,
		statusCell,
		sellerIntroduction,
		closeBindDialog,
		reasonDialog,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: 1,
		},
	},
	data() {
		return {
			title: '协作绑定记录', // 弹窗标题
			visible: false, // 弹窗显隐
			list: [], // 列表数据
			total: 0, // 列表总数
			pageInfo: {
				page_index: 1, // 页码
				page_size: 20, // 每页条数
			},
			loading: false, // 表格加载状态
			shopId: 0,
			wrapperClosable: true,
		};
	},

	created() {
		this.initData();
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show(id = 0) {
			this.shopId = id;
			this.visible = true;
			this.getList();
		},
		//获取列表
		async getList() {
			this.loading = true;
			const { platformId, shopId } = this;
			try {
				const { list = [], page = {} } = await cooperativeList({ ...this.pageInfo, shopId, platformId });
				this.list = list;
				this.total = `${page.itemTotal || 0}`;
			} finally {
				this.loading = false;
			}
		},
		closeBind(bindId) {
			this.$refs.closeBindDialog.show(bindId);
		},
		closeBindReason(remarks) {
			this.$refs.reasonDialog.show(remarks);
		},
		// 清空数据并关闭弹窗
		handleClose() {
			// 清空数据
			this.list = [];
			this.total = 0;
			this.shopId = 0;
			this.pageInfo = {
				page_index: 1,
				page_size: 20,
			};
			this.loading = false;
			// 关闭弹窗
			this.visible = false;
		},
		// 每页展示条数变化
		sizeChange(val) {
			this.pageInfo.page_size = val;
			this.getList();
		},
		// 页数变化
		currentChange(val) {
			this.pageInfo.page_index = val;
			this.getList();
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 点击蒙版是否关闭
			this.wrapperClosable = true;
		},
		refresh() {
			this.getList();
			this.$emit('refresh');
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.content {
	.tips {
		padding: 8px 16px;
		border: 1px solid #5091ff;
		background: #f0f5ff;
	}
	.searchBtn {
		width: 70px;
		background-color: @color-primary;
		color: #ffffff;
		font-size: 13px;
		border-top-left-radius: 2px;
		border-bottom-left-radius: 2px;
		position: absolute;
		right: 0;
		top: 0px;
		border: 1px solid @color-primary;
	}
	::v-deep .el-radio {
		margin-right: 10px;
	}
}
.drawer-footer {
	background-color: #fff;
	z-index: 999;
}
</style>
